<script>
	import TwoImages from "./TwoImages.svelte";
	import ThreeImages from "./ThreeImages.svelte";
	import OneImage from "./OneImage.svelte";
	export let heading;
	export let text;
	export let textAfterImages = null;
	export let image1 = null;
	export let image2 = null;
	export let image3 = null;
	export let subtitle1 = null;
	export let subtitle2 = null;
	export let subtitle3 = null;
  export let content;
  export let elem = null;
</script>

<div class="fullscreen" bind:this={elem}>
	<div class="content">
		{#if heading} <div class="heading">{@html heading}</div>{/if}

		{#if content}
			{#each content as elem}
				{#if elem.text}
					<div class="text">{@html elem.text}</div>
				{/if}

				{#if elem.oneimage}
					<OneImage image1={elem.oneimage.image1} subtitle1={elem.oneimage.subtitle1} />
				{/if}

				{#if elem.twoimages}
					<TwoImages
						image1={elem.twoimages.image1}
						image2={elem.twoimages.image2}
						subtitle1={elem.twoimages.subtitle1}
						subtitle2={elem.twoimages.subtitle2}
					/>
				{/if}

				{#if elem.threeimages}
					<ThreeImages
						image1={elem.threeimages.image1}
						image2={elem.threeimages.image2}
						image3={elem.threeimages.image3}
						subtitle1={elem.threeimages.subtitle1}
						subtitle2={elem.threeimages.subtitle2}
						subtitle3={elem.threeimages.subtitle3}
						subtitleFull={elem.threeimages.subtitleFull}
					/>
				{/if}
			{/each}
		{/if}

		{#if !content}
			{#if text} <div class="text">{@html text}</div>{/if}
			{#if image1 && !image2 && !image3}
				<OneImage {image1} {subtitle1} />
			{/if}

			{#if image1 && image2 && !image3}
				<TwoImages {image1} {image2} {subtitle1} {subtitle2} />
			{/if}

			{#if image1 && image2 && image3}
				<ThreeImages {image1} {image2} {image3} {subtitle1} {subtitle2} {subtitle3} />
			{/if}
			{#if textAfterImages} <div class="text">{@html textAfterImages}</div>{/if}
		{/if}
	</div>
</div>

<style>
	.fullscreen {
		position: relative;
		min-height: 100vh;
		color: #fff;

		/* #151A27 = 21, 26, 39 */
		/*
		padding: 220px 20px;
		background: linear-gradient(
			to bottom,
			rgba(21, 26, 39, 0) 0%,
			rgba(21, 26, 39, 1) 200px,
			rgba(21, 26, 39, 1) calc(100% - 200px),
			rgba(21, 26, 39, 0) 100%
    );
    margin-bottom: calc(-300px - 25vh);
    */
    padding: 20px;
    margin-bottom: -50vh;
  }

	.fullscreen:last-child {
    margin-bottom: 0;
    min-height: 10vh;
  }

	@media (max-width: 580px) {
		.fullscreen {
			/*
      padding: 220px 0;
      */
			padding: 0;
		}
	}

	.content {
		position: relative;
		z-index: 2;
		background: none;
	}

	.heading {
		font-weight: 700;
		font-size: 34px;
		line-height: 41px;
		margin-bottom: 20px;
		max-width: 620px;
		margin: 0 auto;
	}

	@media (max-width: 580px) {
		.heading {
			padding: 20px 20px 0 20px;
		}
	}

	.text {
		text-rendering: optimizeLegibility;
		max-width: 620px;
		margin: 0 auto;
	}

	@media (max-width: 580px) {
		.text {
			padding: 1px 20px 20px 20px;
		}
	}

	.background {
		position: sticky;
		z-index: 1;
		top: 0;
		left: -20px;
		height: 100vh;
		width: 100vw;
		content: "";
		box-sizing: border-box;
		background-repeat: no-repeat;
		background-size: auto 100%;
		background-position: center center;
	}
	@media (min-width: 580px) {
		.background {
			background-image: none !important;
			filter: blur(54px);
			transform: scale(1.1);
			background-color: rgba(0, 0, 0, 1);
			width: 100%;
			height: 100%;
			left: 0;
		}
	}
</style>
